"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { buildBreadcrumbJsonLd } from "@utils/breadcrumbJsonLd";
import customBreadcrumbRoutes from "@data/config/custom-breadcrumb-routes.json";

export default function BreadcrumbJsonLd() {
  const pathname = usePathname();
  const hasCustomBreadcrumb = customBreadcrumbRoutes.routes.includes(pathname);
  const jsonLd = useMemo(() => buildBreadcrumbJsonLd(pathname), [pathname]);

  if (!jsonLd || hasCustomBreadcrumb) {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
